/* Keep listing history separate from the server-rendered category hierarchy. */
(() => {
  'use strict';
  const page = document.querySelector('[data-hanataba-page]');
  if (!page) return;
  const key = 'hanataba:list-return:v1';
  const maxAge = 30 * 60 * 1000;
  const listingPath = /\/(?:collections\/[^/]+|search)\/?$/;
  const productHandle = url => url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  const safeListing = value => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && listingPath.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };

  if (page.dataset.pageType === 'collection' || page.dataset.pageType === 'search') {
    const remember = event => {
      const link = event.target.closest('a[href]');
      if (!link || link.closest('.quickbuy-container') || link.classList.contains('quickbuy-toggle')) return;
      const target = new URL(link.href, location.origin);
      const handle = productHandle(target);
      if (target.origin !== location.origin || !handle) return;
      const source = safeListing(location.href);
      if (!source) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({
          url: source.href,
          title: page.dataset.listTitle,
          product: handle,
          time: Date.now()
        }));
      } catch { /* Storage restrictions must not prevent product navigation. */ }
    };
    document.addEventListener('click', remember, true);
    document.addEventListener('auxclick', remember, true);
  }

  if (page.dataset.pageType !== 'product') return;
  const link = document.querySelector('[data-hanataba-back]');
  if (!link) return;
  const record = read();
  const source = record && safeListing(record.url);
  const referrer = safeListing(document.referrer);
  const currentProduct = productHandle(new URL(location.href));
  // A stale record must not affect a fresh visit from a search engine or another site.
  const cameFromList = source && referrer && source.pathname === referrer.pathname;
  if (!source || !cameFromList || record.product !== currentProduct ||
      typeof record.time !== 'number' || Date.now() - record.time > maxAge ||
      Date.now() < record.time || typeof record.title !== 'string' || !record.title.trim()) return;
  link.href = source.href;
  link.querySelector('[data-hanataba-back-text]').textContent =
    `${page.dataset.backLabel} ${record.title}`;
  link.hidden = false;
})();
